export enum OrbitDistributeRewardStep {
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  DISTRIBUTED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  REJECTED_BY_THE_USER,
}
